import { Directive, HostListener, Input, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';
import { ValidationService } from '@shared/services/validation.service';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[sMask]',
})
export class MaskDirective implements OnInit {
  constructor(private ngControl: NgControl) {}

  private static readonly ALPHA = 'A';
  private static readonly NUMERIC = '9';
  private static readonly ALPHANUMERIC = '?';
  private static readonly ANYTHING = '#';
  public static readonly DATE = 'DATE';
  public static readonly CPF = 'CPF';
  public static readonly CEP = 'CEP';
  public static readonly PIS = 'PIS';
  public static readonly CNPJ = 'CNPJ';
  public static readonly PHONE = 'PHONE';
  public static readonly EMAIL = 'EMAIL';
  private readonly regexMap = new Map<string, string>([
    [MaskDirective.ALPHA, '[a-zA-Z]'],
    [MaskDirective.NUMERIC, '\\d'],
    [MaskDirective.ALPHANUMERIC, '\\w|\\d'],
    [MaskDirective.ANYTHING, '.'],
  ]);
  private readonly predefinedMasks = new Map<string, string>([
    [MaskDirective.DATE, '99/99/9999'],
    [MaskDirective.CPF, '999.999.999-99'],
    [MaskDirective.CEP, '99999-999'],
    [MaskDirective.PIS, '999.99999.99-9'],
    [MaskDirective.CNPJ, '99.999.999/9999-99'],
    [MaskDirective.PHONE, '+99(99)99999-9999'],
    [MaskDirective.EMAIL, ''],
  ]);

  @Input()
  public mask: string;

  // tslint:disable-next-line:no-input-rename
  @Input('mask-type')
  public type: string;

  ngOnInit() {
    if (this.type && this.predefinedMasks.get(this.type)) this.mask  = this.predefinedMasks.get(this.type);

    const validators = [this.ngControl.control.validator];

    if (this.type) {
      switch (this.type) {
        case MaskDirective.CPF:
          validators.push(control => ValidationService.cpf(control));
          break;
        case MaskDirective.CEP:
          validators.push(control => ValidationService.cep(control));
          break;
        case MaskDirective.PIS:
          validators.push(control => ValidationService.pis(control));
          break;
        case MaskDirective.CNPJ:
          validators.push(control => ValidationService.cnpj(control));
          break;
        case MaskDirective.PHONE:
          validators.push(control => ValidationService.telefone(control));
          break;
        case MaskDirective.EMAIL:
          validators.push(control => ValidationService.email(control));
          break;
        case MaskDirective.DATE:
          validators.push(control => ValidationService.date(control));
          break;
        default:
          validators.push(control => ValidationService.custom(control, this.translateMask()));
      }
    }

    if (this.ngControl && this.ngControl.control) {
      this.ngControl.control.setValidators(validators.filter(v => v != null));
    }
  }

  private eval(value: string, i: number) {
    let returnValue = '';
    const maskChar = this.mask.charAt(i);
    const valueChar = value.charAt(i);
    const regex = this.regexMap.get(maskChar) ? new RegExp(this.regexMap.get(maskChar), 'i') : null;

    if ((regex && regex.test(valueChar)) || maskChar === valueChar) returnValue += valueChar;
    else {
      const nextMaskChar = this.mask.charAt(i + 1);
      const newRegex = this.regexMap.get(nextMaskChar) ? new RegExp(this.regexMap.get(nextMaskChar), 'i') : null;
      if ((newRegex && newRegex.test(valueChar)) || nextMaskChar === valueChar) returnValue += maskChar + valueChar;
      else returnValue += maskChar;
    }
    return returnValue;
  }

  @HostListener('input', ['$event'])
  public onInput(event: { target: { value?: string } }): void {
    const value = event.target.value;
    if (value && value.trim() !== '' && this.mask && this.mask.trim() !== '') {
      let returnValue = '';
      for (let i = 0; i < Math.min(this.mask.length, value.length); i++) {
        returnValue += this.eval(value, i);
      }
      this.ngControl.control.setValue(returnValue);
    }
  }

  private translateMask(): string {
    return this.mask
      .split('')
      .map(c => (this.regexMap.get(c) ? this.regexMap.get(c) : c))
      .join('');
  }
}
